export class tItemCateModel {
    itemCateID: string;
    itemCateName: string;
    itemCateName2: string;
    isStock: string;
    isServiceType: string;
    itemCostMethod: number;
    accCode: string;
    accName: string;
    applyShop: string;
    itemCateRemark1: string;
    lastModifyDatetime: Date;
    lastModifyUserID: string;
    inActive: string;
    isServiceDefault:string;
}

export class preDefineCate {

    static other_fee = 'd97';
    static diagonsis = 'd99';
    static diagonsis_service = 'd98';

    static herf = 'b01';
    static concPowder = 'b02';
    static sellHerf = 'b03';
    static pill='b04';
 }
